import { useEffect, useState } from "react";

const useFeatureFlag = (
    flagName: string,
): boolean => {
    const [hasFlag, setHasFlag] = useState<boolean>(false);
    useEffect(() => {
        const params = new URLSearchParams(document.location.search);
        const isUsingFeature = params.get(flagName) === "1";
        setHasFlag(isUsingFeature);
    }, [flagName, setHasFlag]);
    return hasFlag;
};

export default useFeatureFlag;
